import { useMutation } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

interface DeletePaperAttemptRequest {
  attemptId: string;
}

const useDeletePaperAttempt = () => {
  return useMutation({
    mutationFn: async ({ attemptId }: DeletePaperAttemptRequest): Promise<void> => {
      const {
        data: { session },
      } = await supabaseClient.auth.getSession();

      if (!session) {
        throw new Error('Not authenticated');
      }

      // Delete paper attempt by ID (cascade will delete attempt_answers)
      // Note: attemptId is a UUID primary key, so we don't need additional auth checks
      const { data, error } = await supabaseClient
        .from('past_paper_attempts')
        .delete()
        .eq('id', attemptId)
        .select();

      console.log(`Attempted to delete paper attempt ${attemptId}, deleted ${data?.length ?? 0} row(s)`);

      if (error) {
        console.error('Delete error:', error);
        throw new Error(error.message || 'Failed to delete paper attempt');
      }

      if (!data || data.length === 0) {
        throw new Error('Paper attempt not found or already deleted');
      }
    },
  });
};

export default useDeletePaperAttempt;
